"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valsAreEqual = exports.calculateSeconds = exports.wait = exports.isBlob = exports.formatBytes = exports.formatDuration = exports.secsToMins = void 0;
const arrays_1 = require("./arrays");
const datetime_1 = require("./datetime");
const functions_1 = require("./functions");
const objects_1 = require("./objects");
/**
 * Convert seconds to minutes. The returned data type is equal to the provided.
 * @param seconds Number of seconds
 * @returns Number of minutes
 */
function secsToMins(seconds) {
    const mins = Math.floor(+seconds / 60);
    return typeof seconds === 'number' ? mins : `${mins}`;
}
exports.secsToMins = secsToMins;
/**
 * Format a duration string into something human-readable, eg `03:25:23` is far less pleasing than `3hrs 25mins 23secs`.
 * @param duration Colon-separated string (eg '03:25:23')
 * @param options.withSeconds Boolean indicating whether to include seconds
 * @returns Formatted duration string
 */
function formatDuration(duration, options = { withSeconds: false }) {
    let hrs, mins, secs;
    if (typeof duration === 'number')
        ({ hrs, mins, secs } = datetime_1.secsToHHMMSS(duration, { map: true }));
    else {
        const chunks = duration.split(':').map(v => +v);
        if (chunks.length <= 1)
            ({ hrs, mins, secs } = datetime_1.secsToHHMMSS(+duration, { map: true }));
        else if (chunks.length === 3)
            ([hrs, mins, secs] = chunks);
        else
            ([hrs, mins, secs] = [0, +chunks[0], +chunks[1]]);
    }
    let str = '';
    if (hrs)
        str = str.concat(hrs < 10 ? `${hrs}hr ` : `${hrs}hrs `);
    if (mins)
        str = str.concat(mins < 10 ? `${mins}min ` : `${mins}mins `);
    if (((options === null || options === void 0 ? void 0 : options.withSeconds) || !str) && !!secs)
        str = str.concat(secs < 10 ? `${secs}s ` : `${secs}s`);
    return str;
}
exports.formatDuration = formatDuration;
/**
 * Format bytes into human-readable format. The returned unit is determined under the hood and cannot be changed.
 * @param bytes Number or string
 * @returns Human-readable string, eg `12 GB` or `1KB`.
 */
function formatBytes(bytes) {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0, n = parseInt(bytes, 10) || 0;
    while (n >= 1024 && ++l)
        n = n / 1024;
    return `${(n.toFixed(n < 10 && l > 0 ? 1 : 0))} ${units[l]}`;
}
exports.formatBytes = formatBytes;
/**
 * Check if data is a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
 * @param value Data to check
 * @returns Boolean
 */
function isBlob(value) {
    return new Blob([value], { type: 'text/plain' }) instanceof Blob;
}
exports.isBlob = isBlob;
/**
 * Promise which resolves in the given number of seconds.
 * @param seconds Seconds to wait
 */
function wait(seconds) {
    return new Promise((r, j) => setTimeout(r, +seconds * 1000));
}
exports.wait = wait;
/**
 * Convert a time unit and amount to seconds.
 * @param unit `minute`, `hour`, or `day`
 * @param amount Amount of requested unit
 * @returns Number of seconds
 */
function calculateSeconds(unit, amount) {
    if (typeof amount === 'string')
        amount = +amount;
    if (unit === 'minute')
        return amount * 60;
    else if (unit === 'hour')
        return (amount * 60) * 60;
    else if (unit === 'day')
        return ((amount * 24) * 60) * 60;
    else
        return amount;
}
exports.calculateSeconds = calculateSeconds;
function valsAreEqual(value1, value2, options) {
    if (typeof value1 !== typeof value2)
        return false;
    if (typeof value1 === 'function')
        return functions_1.funcsAreEqual(value1, value2, { comparisonStrategy: options === null || options === void 0 ? void 0 : options.functionComparisonStrategy });
    if (typeof value1 === 'object') {
        if (Array.isArray(value1) && Array.isArray(value2))
            return arrays_1.arrsAreEqual([value1, value2], options);
        return objects_1.objsAreEqual(value1, value2, options);
    }
    // Cover strings, numbers, null, and undefined.
    // More: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#Description.
    return (Object.is(value1, value2));
}
exports.valsAreEqual = valsAreEqual;
//# sourceMappingURL=misc.js.map